import { toWSDateString } from "@wingspanhq/fe-component-library";
import { WorkLog } from "@wingspanhq/wingspan-api-sdk";

/**
 * The work log's pay period as a date range, e.g. "Feb 1, 2026 - Feb 15, 2026".
 *
 * Read off the work log's own readonly `periodStart` / `periodEnd` rather than
 * `getPayPeriod`, so the label costs no extra request wherever the work log is
 * already loaded. `undefined` when the period is unknown — a contractor work log
 * has none — so callers can drop the clause instead of printing a half range.
 */
export const selectorWorkLogPayPeriodLabel = (
  workLog: WorkLog | undefined
): string | undefined => {
  const { periodStart, periodEnd } = workLog ?? {};

  if (!periodStart || !periodEnd) {
    return undefined;
  }

  return `${toWSDateString(periodStart, "monthDayYear")} - ${toWSDateString(
    periodEnd,
    "monthDayYear"
  )}`;
};
